import React from 'react'
import classes from './RouteLogs.module.scss'
import { codeAppApiTypes } from '@/types'
import RouteLogsItem from './RouteLogsItem'

export type Props = {
  logs: codeAppApiTypes.components['schemas']['CodeAppLog'][]
}

export const RouteLogs = ({ logs }: Props) => {
  return (
    <div className={classes.root}>
      {logs.map((item) => (
        <RouteLogsItem key={`${item.line}:${item.char}`} item={item} />
      ))}
    </div>
  )
}
